/* © 2023 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import React from 'react';
import { useIntl } from 'react-intl';
import { Typography, Link, Button } from '../..';
import { StyleMarketingBottom, StyleGuestBottom } from './styles';
export var Bottom = function Bottom(_ref) {
  var isPublic = _ref.isPublic,
    isSignedIn = _ref.isSignedIn,
    appName = _ref.appName,
    _ref$hideLearnMore = _ref.hideLearnMore,
    hideLearnMore = _ref$hideLearnMore === void 0 ? false : _ref$hideLearnMore,
    learnMoreText = _ref.learnMoreText,
    supportLink = _ref.supportLink,
    customBottomContent = _ref.customBottomContent,
    handleSignIn = _ref.handleSignIn,
    handleSignUp = _ref.handleSignUp,
    mixpanelProps = _ref.mixpanelProps;
  var intl = useIntl();
  if (isPublic) {
    return /*#__PURE__*/React.createElement(StyleMarketingBottom, {
      className: "EmbersTemplate-marketingBottom-public-root"
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "body",
      marginBottom: 4,
      marginTop: 4
    }, intl.formatMessage({
      id: 'embers.moreDetail.support',
      defaultMessage: 'For more details, please visit {Support}'
    }, {
      Support: /*#__PURE__*/React.createElement(Link, {
        href: supportLink || 'https://support.prometheanworld.com/s/article/1770',
        target: "_blank",
        onClick: function onClick() {
          var _mixpanelProps$tracke, _mixpanelProps$tracke2, _mixpanelProps$tracke3, _mixpanelProps$tracke4;
          return (mixpanelProps === null || mixpanelProps === void 0 || (_mixpanelProps$tracke = (_mixpanelProps$tracke2 = mixpanelProps.tracker).clickPrometheanSupport) === null || _mixpanelProps$tracke === void 0 ? void 0 : _mixpanelProps$tracke.call(_mixpanelProps$tracke2)) || (mixpanelProps === null || mixpanelProps === void 0 || (_mixpanelProps$tracke3 = (_mixpanelProps$tracke4 = mixpanelProps.tracker).mixpanelTrackHelper) === null || _mixpanelProps$tracke3 === void 0 ? void 0 : _mixpanelProps$tracke3.call(_mixpanelProps$tracke4, 'Click Promethean Support'));
        }
      }, intl.formatMessage({
        id: 'embers.support',
        defaultMessage: 'Promethean Support'
      }))
    })));
  } else {
    return /*#__PURE__*/React.createElement(StyleGuestBottom, {
      className: "EmbersTemplate-marketingBottom-guest-root"
    }, !isSignedIn && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
      size: "medium",
      onClick: handleSignUp
    }, intl.formatMessage({
      id: 'embers.marketing.createAccount',
      defaultMessage: 'Create an account'
    })), /*#__PURE__*/React.createElement(Typography, {
      variant: "body",
      className: "EmbersTemplate-marketingBanner-signIn-info",
      marginTop: 3
    }, intl.formatMessage({
      id: 'embers.marketing.freeAccount',
      defaultMessage: '{appName} is free with a Promethean account!'
    }, {
      appName: appName
    }), ' ', intl.formatMessage({
      id: 'embers.marketing.alreadyHasAccount',
      defaultMessage: 'Already have an account? {signIn}'
    }, {
      signIn: /*#__PURE__*/React.createElement(Link, {
        onClick: handleSignIn
      }, intl.formatMessage({
        id: 'embers.header.avatar.signIn',
        defaultMessage: 'Sign in'
      }))
    }))), customBottomContent, !hideLearnMore ? /*#__PURE__*/React.createElement(Typography, {
      variant: "body",
      marginTop: 3
    }, learnMoreText || intl.formatMessage({
      id: 'embers.marketing.learnMore',
      defaultMessage: 'To learn more about promethean products, visit {learnPromethean}.'
    }, {
      learnPromethean: /*#__PURE__*/React.createElement(Link, {
        href: "https://learn.prometheanworld.com/",
        target: "_blank",
        onClick: function onClick() {
          var _mixpanelProps$tracke5, _mixpanelProps$tracke6, _mixpanelProps$tracke7, _mixpanelProps$tracke8;
          return (mixpanelProps === null || mixpanelProps === void 0 || (_mixpanelProps$tracke5 = (_mixpanelProps$tracke6 = mixpanelProps.tracker).clickLearnPromethean) === null || _mixpanelProps$tracke5 === void 0 ? void 0 : _mixpanelProps$tracke5.call(_mixpanelProps$tracke6)) || (mixpanelProps === null || mixpanelProps === void 0 || (_mixpanelProps$tracke7 = (_mixpanelProps$tracke8 = mixpanelProps.tracker).mixpanelTrackHelper) === null || _mixpanelProps$tracke7 === void 0 ? void 0 : _mixpanelProps$tracke7.call(_mixpanelProps$tracke8, 'Access Learn Promethean'));
        }
      }, intl.formatMessage({
        id: 'embers.marketing.learnPromethean',
        defaultMessage: 'Learn Promethean'
      }))
    })) : /*#__PURE__*/React.createElement(React.Fragment, null));
  }
};